export default __webpack_public_path__ + "static/media/README.244f7bef.md";